const STORAGE_KEY = 'zenity:returnTo';

export function saveReturnUrl(url: string): void {
  if (isValidReturnUrl(url)) {
    sessionStorage.setItem(STORAGE_KEY, url);
  }
}

export function consumeReturnUrl(): string | null {
  const url = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (url && isValidReturnUrl(url)) {
    return url;
  }
  return null;
}

export function clearReturnUrl(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

function isValidReturnUrl(url: string): boolean {
  return url.startsWith('/app') && !url.includes('://');
}
